import {Module} from "vuex"
import {RooteState} from "@/store/index";

export interface SideBarState{
  isOpen: boolean
}

export const sideBar: Module<SideBarState, RooteState> = {
  namespaced: true,
  state: () => ({
    isOpen: false
  }),
  mutations: {
    useSideBar(state){
      state.isOpen = !state.isOpen
    }
  },
}